export interface AddSubAccountMallAuthParams {
  /** 子账号uid */
  uid: number;
  /** 店铺列表 */
  authMallIdList: Array<number>;
}

export interface DeleteSubAccountMallAuthParams {
  /** 子账号uid */
  uid: number;
  /** 店铺列表 */
  authMallIdList: Array<number>;
}

export interface QuerySubAccountAuthMallListParams {
  /** 子账号uid */
  uid: number;
}
export interface AuthMallListItem {
  mallId?: number;
  mallName?: string;
  mallLogo?: string;
  /** 当前子账号是否有权限。0-无权限；1-有权限 */
  status?: AuthMallStatusEnums;
}
export enum AuthMallStatusEnums {
  /** 无权限 */
  NO_AUTH = 0,
  /** 有权限 */
  HAS_AUTH = 1,
}
export interface QuerySubAccountAuthMallListResult {
  /** 有权限的授权店铺列表 */
  authMallList?: Array<AuthMallListItem>;
}

export interface QuerySubAccountListResult {
  /** 子账号信息列表 */
  subAccountList?: Array<SubAccountListItem>;
}
export interface AddOrDeletedSubAccountLabelAuthParams {
  /** 子账号uid */
  uid: number;
  /** 添加权限设置true，删除权限设置false */
  labelAuth: boolean;
}
export type QuerySubAccountListParams = object;
export interface SubAccountListItem {
  /** 子账号uid */
  uid?: number;
  /** 授权品牌个数 */
  authBrandCount?: number;
  /** 授权店铺个数 */
  authMallCount?: number;
  /** 是否有人群包管理权限 */
  hasLabelAuth?: boolean;
  /** 是否主账号 */
  mallOwner?: boolean;
  /** 子账号名称 */
  username?: string;
}
export interface QuerySubAccountListResult {
  /** 子账号信息列表 */
  subAccountList?: Array<SubAccountListItem>;
}
export type AddOrDeletedSubAccountLabelAuthResult = object;

export interface BrandInfoListItem {
  brandName?: string;
  brandId?: number;
  /** 当前子账号是否有权限。0-无权限；1-有权限 */
  status?: number;
}
export interface SubAccountAuthBrandListResult {
  /** 授权品牌列表 */
  brandInfoList?: Array<BrandInfoListItem>;
}

export interface SubAccountBrandAuthParams {
  /** 子账号uid */
  uid: number;
  /** 品牌列表 */
  authBrandIdList: Array<number>;
}
